export const selfServiceDe = {
    uploadDocument: 'Dokument hochladen',
    chooseDocumentFile: 'Datei auswählen (erforderlich)',
    documentName: 'Name (erforderlich)',
    uploadingDocument: 'Datei wird hochgeladen…',
    openDocument: 'Dokument öffnen',
    requestUpdated: 'Anfrage aktualisiert',
    requestSubmitted: 'Anfrage eingereicht',
    requestCancelled: 'Anfrage zurückgezogen',
    cancelRequest: 'Anfrage zurückziehen',
    pendingValue: 'Beantragt: {{value}}',
    currentlyUsed: 'Aktuell verwendet',
    waitingForApproval: 'Wartet auf Freigabe',
    pendingHint: 'Bearbeite und speichere Deine Änderungen, um Deine ausstehende Anfrage zu ersetzen.',
    alwaysVisibleHint: 'Die Anzeige grundlegender persönlicher Daten und Kontaktdaten kann nicht deaktiviert werden, da Mitglieder diese Felder in der Vereins-App auch bei deaktiviertem Self-Service sehen können. Bearbeitung und Freigabe können für bearbeitbare Felder weiterhin eingestellt werden.',
    defaultReviewers: 'Standardprüfende',
    reviewerRules: 'Prüfregeln',
    reviewerRulesHint: 'Prüfende Personen aus allen passenden Regeln werden zusammengeführt. Die Bedingungen verwenden die aktuell gespeicherten Kontaktdaten. Prüfende Personen benötigen weiterhin die Berechtigung für jedes geänderte Feld.',
    reviewerRule: 'Regel {{number}}',
    reviewerContactType: 'Kontakttyp',
    reviewerContactTypeHint: 'Wähle einen Kontakttyp, um seine Eigenschaften und benutzerdefinierten Felder zu verwenden. Wenn Du den Typ änderst, wird die Bedingung zurückgesetzt.',
    allContactTypes: 'Alle Kontakttypen',
    reviewerCondition: 'Kontaktbedingung',
    addReviewerRule: 'Prüfregel hinzufügen',
    removeReviewerRule: 'Regel entfernen',
    invalidReviewerRule: 'Diese Regel verweist auf ein fehlendes oder inkompatibles Feld und wird ignoriert. Bearbeite die Bedingung oder entferne die Regel.',
    assignment: 'Zuweisung',
    assignedToMe: 'Mir zugewiesen',
    allAssignments: 'Alle Änderungen',
    clearContactFilter: 'Alle Kontakte anzeigen',
    contactFilter: 'Kontakt',
    yes: 'Ja',
    no: 'Nein',
    title: 'Self-Service',
    description: 'Mitglieder können ihre Daten in der Vereins-App einsehen und aktualisieren. Du legst fest, auf welche Eigenschaften sie zugreifen dürfen und ob Änderungen sofort übernommen oder geprüft werden. Alle Änderungen werden im Verlauf festgehalten.',
    settings: 'Einstellungen',
    propertiesTitle: 'Eigenschaften',
    changes: 'Änderungen',
    myChanges: 'Meine Änderungen',
    enabled: 'Self-Service aktivieren',
    accessLimits: 'Self-Service-Zugriff einschränken',
    accessLimitsHint: 'Wähle aus, wer den Self-Service für diese Mitgliedschaft nutzen darf. Lass alle Felder leer, um allen Zugriff zu erlauben. Ein Kontakt muss jede festgelegte Kategorie und darin mindestens einen Wert erfüllen. Andere Kontakte behalten die grundlegende Mitgliedschaftsansicht ohne Bearbeitungsmöglichkeit.',
    reviewers: 'Prüfende Personen',
    ownerFallback: 'Standardprüfende erhalten Änderungen, wenn keine passende Regel eine Person mit den erforderlichen Berechtigungen enthält. Wenn keine standardmäßig prüfende Person berechtigt ist, erhalten die Organisationsinhaber die Änderungen.',
    search: 'Eigenschaften suchen',
    property: 'Eigenschaft',
    access: 'Zugriff für Mitglieder',
    selected: '{{count}} ausgewählt',
    modes: { read: 'Anzeigen', immediate: 'Bearbeiten', review: 'Freigabe erforderlich' },
    modeHints: {
        read: 'Mitglieder können diese Eigenschaft im Self-Service sehen. Wenn Du Anzeigen deaktivierst, werden auch Bearbeiten und Freigabe erforderlich deaktiviert. Die Eigenschaft wird ausgeblendet und zählt als ungenutzt.',
        immediate: 'Mitglieder können diese Eigenschaft bearbeiten. Wenn Du Bearbeiten aktivierst, wird auch Anzeigen aktiviert. Wenn Du Bearbeiten deaktivierst, wird auch Freigabe erforderlich deaktiviert. Ohne Freigabe werden Änderungen direkt übernommen. Nur für bearbeitbare Eigenschaften verfügbar.',
        review: 'Änderungen werden erst nach einer Freigabe übernommen. Wenn Du Freigabe erforderlich aktivierst, werden auch Anzeigen und Bearbeiten aktiviert. Wenn Du es deaktivierst, bleiben Anzeigen und Bearbeiten aktiviert. Nur für bearbeitbare Eigenschaften verfügbar.',
    },
    groups: { personal: 'Persönliche Angaben', contact: 'Kontaktdaten', payment: 'Zahlungsdaten', membership: 'Mitgliedschaft', contracts: 'Verträge', documents: 'Dokumente' },
    propertyDescriptions: {
        alternativeContacts: 'Anzeigen zeigt vorhandene alternative Kontakte. Bearbeiten erlaubt Mitgliedern, neue Einträge hinzuzufügen sowie bestehende Einträge zu ändern und zu entfernen. Bei verknüpften Kontakten werden Änderungen an Namen und Kommunikationsdaten auch im verknüpften Kontaktdatensatz übernommen. Das Entfernen eines Eintrags entfernt nur die Zuordnung als alternativer Kontakt; der verknüpfte Kontakt wird nicht gelöscht. Mit Freigabe erforderlich warten Ergänzungen, Änderungen und Entfernungen auf Genehmigung.',
        contracts: 'Anzeigen zeigt vorhandene Verträge des Kontakts mit ihrem Namen unter Verträge & Beiträge. Aktiviere die einzelnen Vertragseigenschaften darunter, um Beträge, Abrechnungstermine, Status und weitere Angaben anzuzeigen. Ist Anzeigen für Verträge deaktiviert, bleiben alle Verträge und ihre Angaben verborgen, auch wenn einzelne Eigenschaften aktiviert sind. Verträge können nur angezeigt werden.',
        paymentMethod: 'Anzeigen zeigt die aktuelle Zahlungsart. Bearbeiten erlaubt Mitgliedern, eine andere verfügbare Zahlungsart zu wählen. Mit Freigabe erforderlich wird die Änderung erst nach Genehmigung übernommen. Ein Wechsel zur oder von der Lastschrift erfordert auch Bearbeiten für Lastschriftdaten.',
        directDebitDetails: 'Anzeigen zeigt Kontoinhaber und Bankverbindung. Bearbeiten erlaubt Mitgliedern, Kontoinhaber, IBAN und erforderliche BIC gemeinsam mit einer Lastschriftzustimmung zu ändern. Betrifft ein Wechsel der Zahlungsart auch diese Daten, wartet die gesamte Änderung auf Freigabe, sobald eine der Eigenschaften sie erfordert.',
        billingDetails: 'Anzeigen zeigt Rechnungsempfänger, Rechnungsadresse, E-Mail und Versandart. Bearbeiten erlaubt die gemeinsame Änderung; mit Freigabe erforderlich werden Änderungen erst nach Genehmigung übernommen. Sie gelten für das gemeinsame Rechnungskonto und seine Mitgliedschaften. Persönliche Kontaktdaten bleiben getrennt.',
        debitAuthorization: 'Zeigt Mandatsreferenz und Unterschriftsdatum des bestehenden SEPA-Mandats, wenn Lastschrift aktiv ist. Diese Angaben können nur angezeigt werden. Mitglieder erteilen die Lastschriftzustimmung beim Einreichen ihrer Bankverbindung.',
        paymentOverview: 'Zeigt offene Rechnungen, offene Gutschriften und Guthaben auf dem Rechnungskonto sowie einen Link zu vorhandenen Belegen. Die Beträge werden aus dem Rechnungskonto berechnet und können nur angezeigt werden.',
        onlinePaymentMethods: 'Anzeigen zeigt gespeicherte Online-Zahlungsmittel und ihren Status. Bearbeiten erlaubt Mitgliedern, sie beim Zahlungsanbieter einzurichten oder zu ersetzen. Diese Änderungen gelten sofort und können keine Freigabe erfordern. Der Wechsel der Zahlungsart der Mitgliedschaft wird separat gesteuert.',
        documents: 'Anzeigen erlaubt Mitgliedern, Dokumente einzusehen und herunterzuladen, die mit ihrem Kontakt geteilt wurden. Bearbeiten erlaubt zusätzlich das Hochladen neuer Dokumente. Mit Freigabe erforderlich werden Uploads erst nach Genehmigung hinzugefügt. Bestehende Dokumente können Mitglieder weder bearbeiten noch löschen.',
    },
    deliveryMethods: { none: 'Kein automatischer Versand', email: 'E-Mail', postal: 'Post' },
    contractFields: {
        amount: 'Nächster Einzugsbetrag',
        dueAt: 'Nächster Abrechnungstermin',
        interval: 'Abrechnungsintervall',
        status: 'Status',
        startAt: 'Beginn',
        endAt: 'Ende',
        terminatedAt: 'Kündigung erklärt am',
    },
    properties: {
        documents: 'Mit dem Kontakt geteilte Dokumente',
        person: { firstName: 'Vorname', lastName: 'Nachname', birthdate: 'Geburtsdatum', gender: 'Geschlecht' },
        address: 'Adresse',
        communication: { email: 'E-Mail', phone: 'Telefon', mobilePhone: 'Mobiltelefon' },
        alternativeContacts: 'Alternative Kontakte',
        paymentMethod: 'Zahlungsart',
        directDebitDetails: 'Lastschriftdaten',
        billingDetails: 'Rechnungsdaten',
        debitAuthorization: 'Lastschriftmandat',
        paymentOverview: 'Zahlungsübersicht',
        onlinePaymentMethods: 'Gespeicherte Online-Zahlungsmittel',
        departments: 'Abteilungen',
        contracts: 'Verträge',
    },
    fields: {
        billingAddress: 'Rechnungsadresse',
        receiptSendMethod: 'Rechnungsversand',
        paymentMethod: 'Zahlungsart',
        entryAt: 'Eintritt',
        exitAt: 'Austritt',
        name: 'Name',
        description: 'Beschreibung',
        email: 'E-Mail',
        phone: 'Telefon',
        mobilePhone: 'Mobiltelefon',
        firstName: 'Vorname',
        lastName: 'Nachname',
        iban: 'IBAN',
        bic: 'BIC',
        accountHolderName: 'Kontoinhaber',
        country: 'Land',
        state: 'Bundesland / Region',
        zip: 'Postleitzahl',
        city: 'Ort',
        addressLine: 'Straße und Hausnummer',
        details1: 'Adresszusatz',
        details2: 'Weiterer Adresszusatz',
    },
    current: 'Aktuell',
    proposed: 'Beantragt',
    submitted: 'Eingereicht',
    reviewRequired: 'Diese Änderung muss bestätigt werden.',
    conflict: 'Seit der Einreichung geändert',
    rejectHint: 'Diese Anfrage ablehnen? Die gespeicherten Angaben bleiben unverändert.',
    conflictHint: 'Prüfe den aktuellen Wert, bevor Du diese Änderung annimmst.',
    accept: 'Annehmen',
    reject: 'Ablehnen',
    withdraw: 'Zurückziehen',
    correct: 'Korrigieren',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
    saved: 'Änderungen gespeichert',
    savedResult: '{{applied}} übernommen · {{pending}} ausstehend',
    reviewed: 'Prüfung gespeichert',
    empty: 'Keine Änderungen',
    emptyHint: 'Eingereichte Änderungen werden hier angezeigt.',
    noProperties: 'Keine passenden Eigenschaften',
    noPropertiesHint: 'Versuche einen anderen Suchbegriff.',
    noValue: 'Nicht angegeben',
    removed: 'Eintrag entfernen',
    all: 'Alle',
    pending: 'Ausstehend',
    debitAuthorization: 'Ich ermächtige die Organisation, Lastschriften von diesem Konto einzuziehen.',
    errors: {

        disabled: 'Änderungen im Self-Service sind nicht verfügbar.',
        forbidden: 'Du kannst diese Eigenschaft nicht ändern.',
        changed: 'Diese Angaben wurden geändert. Lade sie neu und prüfe den aktuellen Wert.',
        invalidPayment: 'Wähle eine verfügbare Zahlungsart und ergänze die erforderlichen Angaben.',
        bankUnavailable: 'Lastschrift ist für dieses Konto nicht verfügbar.',
        reviewer: 'Du darfst diese Änderungen nicht prüfen.',
        missing: 'Diese Änderung ist nicht mehr ausstehend.',
        authorization: 'Bestätige die Lastschriftermächtigung.',
        unavailable: 'Diese Eigenschaft ist nicht mehr verfügbar.',
    },
    notifications: {
        reviewTitle: 'Kontaktänderungen prüfen',
        reviewMessage: '{{name}} hat Änderungen eingereicht.',
        outcomeTitle: 'Deine Kontaktänderungen',
        outcomeMessage: 'Deine Organisation hat Deine Änderungen geprüft.',
        open: 'Änderungen anzeigen',
    },
}
